import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { cloneDeep } from 'lodash-es';
import React, { useEffect, useReducer, useRef, useState } from 'react';
import { uploadAvatar } from '../../service/common';
import { useMsgFail } from '../../utils/antd-message';
import { getDefaultAvartar, runAtNextFrame, wrapAvartarUrl } from '../../utils/common';
import '../../styles/input.less';
import '../../styles/reset/antd-form.less';
import './index.less';
import { updateCurrentAccount } from '../../service/login';
import { BtnSave } from '../personal-data/components/btn-save';
import { useStatistics } from '../../utils/statistics';
var fiveM = 5 * 1024 * 1024;
var defaultDetail = {
  accountId: undefined,
  avatar: '',
  email: '',
  nickname: '',
  phone: '',
  wxBound: false,
  wxNickName: '',
  hasPassword: false
};
export function PerfectData(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    currentAccount = _ref.currentAccount,
    tenantName = _ref.tenantName,
    onChange = _ref.onChange,
    onSuccess = _ref.onSuccess,
    onError = _ref.onError,
    _ref$isIndependent = _ref.isIndependent,
    isIndependent = _ref$isIndependent === void 0 ? true : _ref$isIndependent,
    active = _ref.active;
  useStatistics('PerfectData');
  var MsgFail = useMsgFail();
  var _useReducer = useReducer(function (pre, cur) {
      var result = _objectSpread(_objectSpread({}, pre), cur);
      runAtNextFrame(function () {
        onChange && onChange(result);
      });
      return result;
    }, cloneDeep(currentAccount || defaultDetail)),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    detail = _useReducer2[0],
    setDetail = _useReducer2[1];
  var uploadInput = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSaving = _useState2[0],
    setIsSaving = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showReUpload = _useState4[0],
    setShowReUpload = _useState4[1];
  var handleClickUpload = function handleClickUpload() {
    var _uploadInput$current;
    (_uploadInput$current = uploadInput.current) === null || _uploadInput$current === void 0 ? void 0 : _uploadInput$current.click();
  };
  var uploadImage = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(file) {
      var formData, _yield$uploadAvatar, _yield$uploadAvatar$d, result, code, message;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            formData = new FormData();
            formData.append('image', file);
            _context.prev = 2;
            _context.next = 5;
            return uploadAvatar(formData);
          case 5:
            _yield$uploadAvatar = _context.sent;
            _yield$uploadAvatar$d = _yield$uploadAvatar.data;
            result = _yield$uploadAvatar$d.result;
            code = _yield$uploadAvatar$d.code;
            message = _yield$uploadAvatar$d.message;
            console.log(result);
            if (code === '0') {
              setDetail({
                avatar: result
              });
            } else {
              MsgFail(message);
            }
            _context.next = 18;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](2);
            console.error('upload fail', _context.t0);
            MsgFail('上传失败，请稍候再试');
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 14]]);
    }));
    return function uploadImage(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var onInputChange = function onInputChange(e) {
    console.log(e.target.files[0]);
    var file = e.target.files[0];
    if (file.size > fiveM) {
      MsgFail('头像图片大小不得超过5M');
    } else {
      uploadImage(file);
    }
    e.target.value = '';
  };
  var onSaveDetail = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _yield$updateCurrentA, _yield$updateCurrentA2, code, message;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            if (!(!detail.nickname || isSaving)) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            setIsSaving(true);
            _context2.next = 6;
            return updateCurrentAccount(detail);
          case 6:
            _yield$updateCurrentA = _context2.sent;
            _yield$updateCurrentA2 = _yield$updateCurrentA.data;
            code = _yield$updateCurrentA2.code;
            message = _yield$updateCurrentA2.message;
            if (code === '0') {
              onSuccess && onSuccess(detail);
            } else {
              MsgFail(message || '保存失败，请稍候再试');
              onError && onError(code);
            }
            setIsSaving(false);
            _context2.next = 20;
            break;
          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](0);
            console.warn(_context2.t0);
            setIsSaving(false);
            MsgFail('保存失败，请稍候再试');
            onError && onError(_context2.t0);
          case 20:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 14]]);
    }));
    return function onSaveDetail() {
      return _ref3.apply(this, arguments);
    };
  }();
  useEffect(function () {
    setDetail(cloneDeep(currentAccount || defaultDetail));
  }, [currentAccount, active]);
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    onClick: onClick,
    className: "".concat(className, " login-perfect-data")
  }, /*#__PURE__*/React.createElement("div", {
    className: "login-perfect-data-content login-custom-form",
    id: "login-form-override"
  }, /*#__PURE__*/React.createElement("div", {
    className: "login-perfect-data-item-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "login-perfect-data-item-label fontBold"
  }, "\u5934\u50CF"), /*#__PURE__*/React.createElement("div", {
    className: "login-perfect-data-item-value"
  }, /*#__PURE__*/React.createElement("div", {
    className: "login-perfect-data-avartar-wrap",
    onMouseOver: function onMouseOver() {
      return setShowReUpload(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setShowReUpload(false);
    },
    onClick: handleClickUpload
  }, /*#__PURE__*/React.createElement("input", {
    onChange: onInputChange,
    accept: "image/png, image/jpeg",
    ref: uploadInput,
    className: "login-perfect-data-avartar-input",
    type: "file"
  }), /*#__PURE__*/React.createElement("img", {
    src: (detail === null || detail === void 0 ? void 0 : detail.avatar) ? wrapAvartarUrl(detail.avatar) : getDefaultAvartar(),
    className: "login-perfect-data-avartar",
    alt: ""
  }), showReUpload && /*#__PURE__*/React.createElement("div", {
    className: "login-perfect-data-avartar-mask fontBold"
  }, "\u4FEE\u6539")))), /*#__PURE__*/React.createElement("div", {
    className: "login-perfect-data-item-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "login-perfect-data-item-label fontBold"
  }, "\u59D3\u540D"), /*#__PURE__*/React.createElement("div", {
    className: "login-perfect-data-item-value login-input-wrap",
    style: {
      height: '36px'
    }
  }, /*#__PURE__*/React.createElement("input", {
    className: "login-input-normal",
    type: "text",
    placeholder: "\u8BF7\u8F93\u5165\u59D3\u540D",
    value: detail.nickname,
    maxLength: 20,
    onChange: function onChange(e) {
      return setDetail({
        nickname: e.target.value.trim()
      });
    }
  }))), !isIndependent && tenantName && /*#__PURE__*/React.createElement("div", {
    className: "login-perfect-data-item-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "login-perfect-data-item-label fontBold"
  }, "\u5B66\u6821"), /*#__PURE__*/React.createElement("div", {
    className: "login-perfect-data-item-value"
  }, tenantName)), /*#__PURE__*/React.createElement(BtnSave, {
    confirmDisabled: !detail.nickname,
    onConfirm: onSaveDetail,
    isSaving: isSaving
  })));
}